module.exports = __webpack_public_path__ + "media/images/icons/favicon-47033817fe22b07f94ed004dd2579825.ico";